<div class="emds" id="{{Id}}">
  <div class="modal-default">
    <div class="modal-header">
      {{message?.Header}}
    </div>
    <div class="modal-body">
      <fp-message-reply [baseId]="baseId"
                  [readOnly]="readOnly"
                  [messageId]="message.MessageId"
                  [alertWarnings]="alertWarnings"
                  (dataSaved)="close($event)">
      </fp-message-reply>
    </div>
    <div class="modal-footer">
    </div>
  </div>
</div>
